import { useRef, useEffect, useMemo } from 'react'
import Cleave from 'cleave.js/react';
import 'cleave.js/dist/addons/cleave-phone.tr.js'

import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import classNames from 'classnames';

const TextInput = ({
	// eslint-disable-next-line no-unused-vars
	inputType: inputTypeProp, onChangePlainValue, onChange, initialized,
	className, label: labelProp, validationError, maskOptions: maskOptionsProp,
	autoComplete, value, mask, innerContent, placeholder, icon,
	hideError,
	...props
}) => {
	const inputRef = useRef();

	// Set initial plain value.
	const plainValue = useMemo(() => {
		if(inputTypeProp === 'phone') {
			let plainValue = value.replace(/\s/g,'');
			if(!plainValue.startsWith('+')){
				if(plainValue.startsWith('00')){
					plainValue = plainValue.replace('00', '+');
				}
				else if(plainValue.startsWith('0')) {
					plainValue = '+9' + plainValue;
				}
				else {
					plainValue = '+90' + plainValue;
				}
			}
			return plainValue;
		}
		else if(inputTypeProp === 'price') {
			return (value ?? '').toString().replace(/[^\d,-]/g, '').replace(',', '.')
		}
		return (value ?? '').toString();
	}, [value, inputTypeProp])

	const isFull = useMemo(() => !!value?.length, [value])

	const label = useMemo(() => {
		return labelProp ?? placeholder;
	}, [placeholder, labelProp])

	useEffect(() => {
		onChangePlainValue(plainValue);
	}, [plainValue])

	const { component: Component, ...computedProps } = useMemo(() => {
		let props = {
			type: 'text',
			component: 'input'
		}
		if(inputTypeProp === 'phone') {
			props.component = Cleave;
			props.options = {
				phone: true,
				phoneRegionCode: 'TR',
				delimiter: ' ',
			}
			props.inputMode = 'tel';
			props.pattern = '[0-9.]+';
		}
		else if(inputTypeProp === 'number') {
			props.component = Cleave;
			props.options = {
				numeral: true,
				numeralThousandsGroupStyle: 'none',
				stripLeadingZeroes: false,
			}
			props.inputMode = 'numeric';
			props.pattern = '[0-9.]';
		}
		else if(inputTypeProp === 'price') {
			props.component = Cleave;
			props.options = {
				numeral: true,
				prefix: ` ${process.config.mainCurrency.symbol}`,
				tailPrefix: true,
				numeralDecimalMark: ',',
				delimiter: '.',
				
			}
			props.inputMode = 'numeric';
			props.pattern = '[0-9.]';
		}
		else if(inputTypeProp === 'date') {
			props.component = Cleave;
			props.options = {
				date: true,
				delimiter: '/',
				datePattern: ['d', 'm', 'Y'],
			}
			props.inputMode = 'numeric';
			props.pattern = '[0-9.]';
		}
		else if(inputTypeProp === 'time') {
			props.component = Cleave;
			props.options = {
				time: true,
				timePattern: ['h', 'm'],
			}
			props.inputMode = 'numeric';
			props.pattern = '[0-9.]';
		}
		else if(mask) {
			props.component = Cleave;

			if(mask === 'creditcard') {
				props.pattern = '[0-9]*'
				props.inputMode = 'numeric';

				props.options = {
					creditCard: true,
				}
			}
			else if (mask === 'expiry') {
				props.pattern = '[0-9]*';
				props.inputMode = 'numeric';

				props.options = {
					date: true,
					datePattern: ['m', 'y']
				}
			}
			else if (mask === 'iban') {
				props.pattern = '[0-9]*';
				props.inputMode = 'numeric';

				props.options = {
					numericOnly: true,
					prefix: 'TR',
					blocks: [4, 4, 4, 4, 4, 4, 2]
				}
			}
		}

		if(maskOptionsProp) {
			props.options = {
				...(props.options ?? {}),
				...maskOptionsProp,
			}
		}

		return props;
	}, [inputTypeProp, mask, maskOptionsProp])

	const handleChange = e => {
		onChange(e.target.value);
	}

	useEffect(() => {
		if (inputRef.current && typeof inputRef.current === 'function' && inputRef.current.matches(':-internal-autofill-selected')) {
			inputRef.current.click();
		}
	}, [])

	return (
		<div className={classNames('type-text', className, { 'input-full': isFull, 'disabled': props.disabled })}>
			<div className={'inputwrap-outerwrap' + (label ? '' : ' no-label')}>
				{icon &&
					<Icon className="input-icon" name={icon} />
				}
				{label &&
					<label className="input-label" htmlFor={props.id}>
						<div className="label-text">
							{label}
						</div>
					</label>
				}
				<div className="input-innerwrap">
					{innerContent}
					<Component
						ref={inputRef}
						onChange={handleChange}
						className={'inputwrap-input'}
						autoComplete={autoComplete || 'off'}
						value={value}
						placeholder={placeholder ?? label}
						{...computedProps}
						{...props} />
				</div>
				{!!(validationError && !hideError) &&
					<div className="input-error">
						{validationError}
					</div>
				}
			</div>
		</div>
	)
}

export default TextInput;